/** What a Stripe Checkout session pays for, written into its metadata by the backend. */
export const CheckoutPurpose = {
  CREDIT_PACK: 'CREDIT_PACK'
} as const;

export type CheckoutPurpose = (typeof CheckoutPurpose)[keyof typeof CheckoutPurpose];

/** Why a payer may not buy a credit pack now. */
export const CreditPackPurchaseRefusal = {
  MANAGED_CLIENT: 'MANAGED_CLIENT',
  FREE_PLAN: 'FREE_PLAN',
  MANUAL_PLAN: 'MANUAL_PLAN',
  NOT_CREDITS_PLAN: 'NOT_CREDITS_PLAN',
  SUBSCRIPTION_NOT_ACTIVE: 'SUBSCRIPTION_NOT_ACTIVE',
  CHANGE_SCHEDULED: 'CHANGE_SCHEDULED',
  PENDING_DELETION: 'PENDING_DELETION'
} as const;

export type CreditPackPurchaseRefusal =
  (typeof CreditPackPurchaseRefusal)[keyof typeof CreditPackPurchaseRefusal];

/** What made a subscription change its plan. */
export const PlanChangeCause = {
  CHECKOUT: 'CHECKOUT',
  UPGRADE: 'UPGRADE',
  SCHEDULED_CHANGE: 'SCHEDULED_CHANGE',
  CANCELLATION: 'CANCELLATION'
} as const;

export type PlanChangeCause = (typeof PlanChangeCause)[keyof typeof PlanChangeCause];
